import { ContentCopy, Delete } from "@mui/icons-material";
import SmartToyIcon from "@mui/icons-material/SmartToy";
import React, { memo } from "react";
import { Handle } from "react-flow-renderer";
import { useNodeStorage } from "../../../stores/useNodeStorage";

// Paleta indigo/roxo pastel — destaca dos outros nós
const COLORS = {
  bg:       "#f5f3ff",   // fundo do cartão
  border:   "#c4b5fd",   // borda
  accent:   "#7c3aed",   // cor do ícone e handles
  headerBg: "#ede9fe",   // fundo do header interno
  headerTx: "#4c1d95",   // texto do header
  subTx:    "#6d28d9",   // cor do preview de prompt
  badgeBg:  "#7c3aed",   // badge de ferramentas
  shadow:   "0 2px 8px rgba(124,58,237,0.12)",
};

export default memo(({ data, isConnectable, id }) => {
  const storageItems = useNodeStorage();
  const agentCfg = data?.agentSettings || {};
  const isSaved  = !!data?.agentId;

  // Exibição no nó: suporta tanto modo salvo (agentId) quanto inline (agentSettings)
  const nomeAgente  = data?.agentName  || agentCfg.name  || "Agente IA";
  const modelo      = data?.agentModel || agentCfg.model || "gpt-4o";
  const promptText  = isSaved
    ? `📌 Agente salvo #${data.agentId}`
    : agentCfg.systemPrompt
      ? agentCfg.systemPrompt.substring(0, 52) + (agentCfg.systemPrompt.length > 52 ? "…" : "")
      : "Sem prompt configurado";

  // Contador de ferramentas habilitadas
  const tools = agentCfg.tools || {};
  const toolCount = isSaved
    ? (typeof data?.agentToolCount === "number" ? data.agentToolCount : 0)
    : Object.values(tools).filter(Boolean).length;
  const totalTools = 13;

  return (
    <div
      style={{
        backgroundColor: COLORS.bg,
        padding: "8px",
        borderRadius: "14px",
        boxShadow: COLORS.shadow,
        border: `1px solid ${COLORS.border}`,
        minWidth: 190,
      }}
    >
      {/* Handle de entrada (esquerda) */}
      <Handle
        type="target"
        position="left"
        style={{
          background: COLORS.accent,
          width: "14px",
          height: "14px",
          top: "20px",
          left: "-9px",
          border: "2px solid white",
          cursor: "pointer",
        }}
        isConnectable={isConnectable}
      />

      {/* Botões de ação (copiar / deletar) */}
      <div
        style={{
          display: "flex",
          position: "absolute",
          right: 5,
          top: 5,
          cursor: "pointer",
          gap: 6,
        }}
      >
        <ContentCopy
          onClick={() => { storageItems.setNodesStorage(id); storageItems.setAct("duplicate"); }}
          sx={{ width: "12px", height: "12px", color: "#6b7280" }}
        />
        <Delete
          onClick={() => { storageItems.setNodesStorage(id); storageItems.setAct("delete"); }}
          sx={{ width: "12px", height: "12px", color: "#6b7280" }}
        />
      </div>

      {/* Cabeçalho: ícone + nome do agente */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 5,
          marginBottom: 5,
        }}
      >
        <SmartToyIcon
          sx={{ width: "16px", height: "16px", color: COLORS.accent }}
        />
        <span
          style={{
            color: "#111827",
            fontSize: "13px",
            fontWeight: 600,
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            maxWidth: 120,
          }}
        >
          {nomeAgente}
        </span>
      </div>

      {/* Corpo do nó */}
      <div style={{ fontSize: "12px", width: 180 }}>
        {/* Modelo */}
        <div
          style={{
            backgroundColor: COLORS.headerBg,
            borderRadius: "8px",
            padding: "4px 8px",
            marginBottom: "4px",
          }}
        >
          <div
            style={{
              textAlign: "center",
              color: COLORS.headerTx,
              fontSize: "11px",
              fontWeight: 600,
            }}
          >
            {modelo}
          </div>
        </div>

        {/* Preview do prompt */}
        <div
          style={{
            backgroundColor: "rgba(237,233,254,0.6)",
            borderRadius: "6px",
            padding: "4px 7px",
            marginBottom: "4px",
          }}
        >
          <div
            style={{
              color: COLORS.subTx,
              fontSize: "10px",
              lineHeight: 1.35,
              whiteSpace: "normal",
              wordBreak: "break-word",
            }}
          >
            {promptText}
          </div>
        </div>

        {/* Badge de ferramentas habilitadas */}
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <div
            style={{
              backgroundColor: toolCount > 0 ? COLORS.badgeBg : "#9ca3af",
              color: "white",
              borderRadius: "10px",
              padding: "2px 8px",
              fontSize: "9px",
              fontWeight: 700,
              letterSpacing: "0.03em",
            }}
          >
            {toolCount}/{totalTools} tools
          </div>
        </div>
      </div>

      {/* Handle de saída (direita) */}
      <Handle
        type="source"
        position="right"
        id="a"
        style={{
          background: COLORS.accent,
          width: "14px",
          height: "14px",
          top: "50%",
          right: "-9px",
          border: "2px solid white",
          cursor: "pointer",
        }}
        isConnectable={isConnectable}
      />
    </div>
  );
});
